export const Logo = ({ size = 34 }) => (
  <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link" aria-label="rojdijital">
    <svg width={size} height={size} viewBox="0 0 64 64" className="transition-transform duration-700 group-hover:rotate-[60deg]">
      <defs>
        <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7DF9FF" />
          <stop offset="0.5" stopColor="#00F2FE" />
          <stop offset="1" stopColor="#4FACFE" />
        </linearGradient>
      </defs>
      <path d="M32 6 L54 19 L54 45 L32 58 L10 45 L10 19 Z" fill="none" stroke="url(#lg)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M32 6 L32 32 L54 19 M32 32 L10 19 M32 32 L32 58" fill="none" stroke="url(#lg)" strokeWidth="1.8" opacity="0.7" />
      <circle cx="32" cy="32" r="4" fill="#00F2FE" />
    </svg>
    <span className="font-display font-extrabold text-xl tracking-tight text-[#f4f2ec]">
      roj<span className="text-gold-gradient">dijital</span>
    </span>
  </a>
);
